import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=3c5ecfff&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"
import style0 from "./Index.vue?vue&type=style&index=0&id=3c5ecfff&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5ecfff",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c5ecfff')) {
      api.createRecord('3c5ecfff', component.options)
    } else {
      api.reload('3c5ecfff', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=3c5ecfff&scoped=true&", function () {
      api.rerender('3c5ecfff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/examples/profile/basic/Index.vue"
export default component.exports